import React, { useState, useEffect} from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import Preloader from "../../../components/Preloader/Preloader";
import { get_cookies } from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "500px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		borderRadius:5,
		padding: theme.spacing(2, 4, 3),
		width: "500px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
		'&$disabled': {
			color: '#f2f2f2',
		 }
	},
	disabled: {},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function UpdateSystemUser(props) {
	const {user_id, user_details, showModal} = props;

	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [positionData, setPositionData] = useState([]);
	const [branchIdData, setBranchIdData] = useState([]);
	const [userData, setUserData] = useState([]);

	const [positionId, setPositionId] = useState(user_details.position_id);
	const [positionIndex, setPositionIndex] = useState(null); 
	const [branchIdNoIndex, setBranchIdNoIndex] = useState(null);
	const [fname, setFname] = useState('');
	const [mname, setMname] = useState('');
	const [lname, setLname] = useState('');
	const [name, setName] = useState('');
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [branchidno, setBranchidno] = useState(user_details.branchidno);

	const [confirmPassword, setConfirmPassword] = useState("");
	const [oldPassword, setOldPassword] = useState(null);
	const [oldPasswordVerified, setOldPasswordVerified] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [showOldPassword, setShowOldPassword] = useState(false);
	 const [errorMessage, setErrorMessage] = useState("");
	 const [isChangePassword, setIsChangePassword] = useState(false);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [isReadOnly, setIsReadOnly] = useState(false);
	  const [loading, setLoading] = useState(false);

	const handleOpen = () => {
		//getUserData();
		setOpen(true);
	};

	const handleValidation = () => {
		setOpen(true);
	};


	const handleClose = () => {
		setOpen(false);
		setOldPassword("");
		setPassword("");
		setConfirmPassword("");
		setErrorMessage("");
		setIsChangePassword(false);
		setIsReadOnly(false);
		setOldPasswordVerified(false);
	
	};
	const handleChangePasword = () => {
		setIsChangePassword(!isChangePassword);
	};

	const getUserRoleData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_user_roles', {
			}).then(function (res) {
				setPositionData(res.data.data);
				res.data.data.some(function(entry, i) {
					if (entry.position == user_details.position) {
						//index = i;
						// console.log(user_details.position);
						// console.log(i);
						// console.log(i);
						setPositionIndex(i);
						return true;
					}
				});
		  	}).catch(function (error) {	
				// console.log(error);
	  		});
	}
	

	const setUserDetails = () => {
		setName(user_details.name);
		setUsername(user_details.username);
	}
	

	const selectSupplierProps = {
		options: positionData,
		getOptionLabel: (option) => option.position,
	};
	
	const selectBranchIdProps = {
		options: branchIdData,
		getOptionLabel: (option) => option.idno,
	};

	const getIndexofArray = async (property_value, type) => {
		//for position dropdown
		var index = '';
			if(type === 1){
				positionData.some(function(entry, i) {
					if (entry.position == property_value) {
						index = i;
						return true;
					}
				});
		//for branchidno dropdown
			}else if(type === 2){
				branchIdData.some(function(entry, i) {
					if (entry.idno == property_value) {
						index = i;
						return true;
					}
				});
			}
		return index;
	}

	useEffect(() => { //
		if(user_id && open){
			setUserDetails();
			getUserRoleData();
		}
	}, [user_id, open]);



	const allPasswordsMatch =
	password && confirmPassword &&
	password === confirmPassword &&password !== oldPassword;; 
	const isPasswordValid = (pw) => {
		return (
		pw.length >= 8 &&
		/[A-Z]/.test(pw) &&
		/[a-z]/.test(pw) &&
		/[0-9]/.test(pw) &&
		/[!@#$%^&*(),.?":{}|<>]/.test(pw)
		);
		};

	useEffect(() => {
		if(password && confirmPassword){
			if (positionId && username && (password===confirmPassword)) {
				setBtnDisabled(false); // re-enable
			} else {
				setBtnDisabled(true); // re-enable
			}
		}else{
			if (positionId && name && username) {
				setBtnDisabled(false); // re-enable
			} else {
				setBtnDisabled(true); // re-enable
			}
		}
	}, [positionId,name,username]);


		useEffect(() => {
			if(oldPasswordVerified){
			const allFilled =
			username !== "" &&
			password != null &&
			confirmPassword !== "";
			// newPassword !== "";

			if(password != null){
				const allValid = isPasswordValid(password) && allPasswordsMatch;
			
					if (allFilled && allValid) {
					setBtnDisabled(false);
					} else {
					setBtnDisabled(true);
					}
			}
	
			}
			

		}, [username, password, confirmPassword, allPasswordsMatch,isChangePassword,oldPasswordVerified]);
						const requirements = [
			{
			label: "Minimum 8 characters.",
			test: (pw) => pw.length >= 8,
			},
			{
			label: "At least 1 uppercase letter.",
			test: (pw) => /[A-Z]/.test(pw),
			},
			{
			label: "At least 1 lowercase letter.",
			test: (pw) => /[a-z]/.test(pw),
			},
			{
			label: "At least 1 number.",
			test: (pw) => /[0-9]/.test(pw),
			},
			{
			label: "At least 1 symbol (e.g., !@#$%^&*).",
			test: (pw) => /[!@#$%^&*(),.?":{}|<>]/.test(pw),
			},
			  {
			label: "Password and Confirm password must match.",
			test: (pw) => pw === confirmPassword,
			},
						  {
			label: "New password cannot be the same as your current password.",
			test: (pw) => pw !== oldPassword,
			},
			];
	
	// user_id:19
	// position_id:51
	// fname:Mark Daniel
	// mname:Calzita
	// lname:Babaylan
	// username:rakkit699
	// password:Test123
	// branchidno:DAVAOHQ
	const editSystemUser = async () => {
		setLoading(true);
		if((password == confirmPassword) && name && username && branchidno){
			const formData = new FormData();
			formData.append("user_id", user_id);
			formData.append("position_id", positionId);
			formData.append("username", username); 
			formData.append("password", password);
			formData.append("branchidno", branchidno);
			formData.append("name", name);
			formData.append("updatedby", get_cookies('username'));
	
			await axios.post(process.env.REACT_APP_API_URL+'edit_system_user', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if(res.data.status == 1){
					setLoading(false);
					showModal('Updated System User '+ username, 'success');
					handleClose();
					}else{
					setLoading(false);
					showModal('Username is already taken', 'warning');
					// handleClose();
					}

				  }).catch(function (error) {
					setLoading(false);
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
		}else{
			showModal('Passwords must match / Fields must not be empty', 'warning');
			// handleClose();
		}
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		editSystemUser();
    }
    	const handleName = (e) => {
		const value = e.target.value.replace(/[^a-zA-Z ]/g, "");
		setName(value);
    }


	const handleClickShowPassword = (flag) => {
		if(flag === 'password'){
			setShowPassword(!showPassword);
		}else if(flag === 'confirm'){
			setShowConfirmPassword(!showConfirmPassword);
		}else if(flag === 'oldpassword'){
			setShowOldPassword(!showOldPassword);
		}
	  };

	  function hasNumber(myString) {
			if (myString.trim() === "") return false;

			// Allowed: letters, numbers, underscore, dot, dash, @
			const regex = /^[A-Za-z0-9._@\- ]+$/;
			return regex.test(myString);
	  }
	  
	  const validateUsername = (username) => {
		let isValidName = username.match(/^(([a-z])+([0-9])+|([a-z])+)/);
		if(!isValidName){
			setUsername('');
			setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Invalid Username');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}
	  };

	  const validateName = (username,flag) => {
		// let isValidName = username.match(/([a-z])|([A-Z])/);
		let isValidName = hasNumber(username);
		if(!isValidName){
			// setUsername('');
			if(flag==='fname'){
				setFname('');
			}else if(flag === 'mname'){
				setMname('');
			}else if(flag === 'lname'){
				setLname('');
			}
			setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Numbers Not Allowed in Name Fields');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}
	  };

	  const handleMouseDownPassword = (event) => {
		event.preventDefault();
	  };
	  
	   const checkOldPassword = async () => {
		const formData = new FormData();
		if(oldPassword == null || oldPassword ==""){

						setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Old Password must not be empty!');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
			return ;
		}
			formData.append("old_password", oldPassword);
			formData.append("position_id",get_cookies('position_id'));
			formData.append("username", username);
		await axios.post(process.env.REACT_APP_API_URL+'checkOldPassword', formData,{
			}).then(function (res) {
				setOldPasswordVerified(true);
				setIsReadOnly(true);
				setErrorMessage("");

		  	}).catch(function (error) {	
				// console.log(error);
					setIsReadOnly(false);
			setErrorMessage(
			error.response?.data?.message || "❌ Old password is incorrect"
		);
	  		});
	};
	  const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);
	  		const spinnerStyle = {
		border: "4px solid #f3f3f3",
		borderTop: "4px solid #3498db",
		borderRadius: "50%",
		width: "24px",
		height: "24px",
		animation: "spin 1s linear infinite",
		margin: "10px auto",
		};

		const spinKeyframes = `
		@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
		}
		`;

	return (
		<div>
			<Button variant="contained" color="primary" onClick={handleOpen} style={{backgroundColor: "#4caf50", color:"#fff"}}>
				Edit
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
							<style>{spinKeyframes}</style>
						{loading && <div style={spinnerStyle}></div>}
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						{loading == false ?<>						<h4 id="transition-modal-title">Update System User</h4>
						{open && (positionIndex != null)? (<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<Autocomplete
												{...selectSupplierProps}
												id="auto-complete"
												defaultValue={positionData[positionIndex]}
												autoComplete
												includeInputInList
												className={classes.autoComplete}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select User Role"
														margin="normal"
														variant="outlined"
													/>
												)}
												onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														setPositionId(newValue.position_id);
													}else{
														setPositionId(null);
													}
												}}
									/>
								</Grid>		
								<Grid item xs={12} md={12} lg={12} xl={12}> 
									<TextField id="outlined-basic" label="Username" variant="outlined" placeholder="User Name" inputProps={{ 'aria-label': 'User Name' }} value={username} 
									onChange={e => setUsername(e.target.value)}
									onBlur={(e)=>{validateUsername(e.target.value)}}/>
								</Grid>
								<Grid item xs={12} md={12} lg={12} xl={12}> 
									<TextField id="outlined-basic" 
										label="Name" 
										variant="outlined" 
										placeholder="First Name" fullWidth={true} 
										inputProps={{ 'aria-label': 'Full Name'}} 
										value={name} 
										onChange={handleName}
										onBlur={(e)=>{validateName(e.target.value,'name')}}
								/>
								</Grid>	
								{isChangePassword? <>								<Grid item xs={12} md={12} lg={12} xl={12}> 
								<InputLabel htmlFor="outlined-adornment-password">Old Password</InputLabel>
        							  <OutlinedInput
        							    id="outlined-adornment-password"
        							    type={showOldPassword ? 'text' : 'password'}
        							    value={oldPassword}
								    readOnly={isReadOnly}
									fullWidth={true} 
									 error={!!errorMessage} 
        							    onChange={e => setOldPassword(e.target.value)}
        							    endAdornment={
        							      <InputAdornment position="end">
        							        <IconButton
        							          aria-label="toggle password visibility"
        							          onClick={()=>{handleClickShowPassword('oldpassword')}}
        							          onMouseDown={handleMouseDownPassword}
        							          edge="end"
        							        >
        							          {showOldPassword ? <Visibility /> : <VisibilityOff />}
        							        </IconButton>
        							      </InputAdornment>
        							    }
        							    labelWidth={50}
        							/>
									{errorMessage && (
									<p style={{ color: "red", marginTop: "8px" }}>
									{errorMessage}
									</p>
									)}
									{oldPasswordVerified?null:<Button variant="contained" color="primary" onClick={checkOldPassword} style={{marginTop:"8px"}}>Verify Old Password</Button>}
								
							
								</Grid>	
								{oldPasswordVerified?<>
																<ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
								{requirements.map((req, idx) => (
								<li
								key={idx}
								style={{
								color: req.test(password) ? "green" : "red",
								}}
								>
								{req.label}
								</li>
								))}
							</ul>
																<Grid item xs={12} md={12} lg={12} xl={12}> 
									<InputLabel htmlFor="outlined-adornment-password">Enter New Password</InputLabel>
        							  <OutlinedInput
        							    id="outlined-adornment-password"
        							    type={showPassword ? 'text' : 'password'}
        							    value={password}
										fullWidth={true} 
        							    onChange={e => setPassword(e.target.value)}
        							    endAdornment={
        							      <InputAdornment position="end">
        							        <IconButton
        							          aria-label="toggle password visibility"
        							          onClick={()=>{handleClickShowPassword('password')}}
        							          onMouseDown={handleMouseDownPassword}
        							          edge="end"
        							        >
        							          {showPassword ? <Visibility /> : <VisibilityOff />}
        							        </IconButton>
        							      </InputAdornment>
        							    }
        							    labelWidth={50}
        							/>
								</Grid>
								<Grid item xs={12} md={12} lg={12} xl={12}> 
									<InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
        							  <OutlinedInput
        							    id="outlined-adornment-password"
										fullWidth={true} 
        							    type={showConfirmPassword ? 'text' : 'password'}
        							    value={confirmPassword}
        							    onChange={e => setConfirmPassword(e.target.value)}
        							    endAdornment={
        							      <InputAdornment position="end">
        							        <IconButton
        							          aria-label="toggle password visibility"
        							          onClick={()=>{handleClickShowPassword('confirm')}}
        							          onMouseDown={handleMouseDownPassword}
        							          edge="end"
        							        >
        							          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
        							        </IconButton>
        							      </InputAdornment>
        							    }
        							    labelWidth={50}
        							/>
								</Grid>
							</>:null}</>:null}


							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleChangePasword}
									className={classes.buttonMarginRight}
								>
									Change Password
								</Button>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<ColorButton type="submit" disabled={btnDisabled} variant="contained" color="primary" classes={{
    									root: classes.root, 
        								disabled: classes.disabled}}>
									Save
								</ColorButton>
							</div>
						</form>) : (<Preloader />)}	</>:null}
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
